import {Device} from '@/models/Device'
import {Prettify} from '@/utils/Prettify'

export interface DeviceGroup
{
    id: number
    name: string
    devices?: Device[]
}

export type DeviceGroupDraft = Prettify<Partial<DeviceGroup> & {
    name: string
}>

export function createDeviceGroup(): DeviceGroupDraft {
    return {
        id: undefined,
        name: '',
    }
}

